import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Icons as I } from '../pack-icons';
import { useFreePreview } from '../../contexts/FreePreviewContext.jsx';
import { freePublishingState } from '../../lib/freePublishing.js';
import { useDashboardData } from '../../state/DashboardDataContext.jsx';

// GH-1133 S5 (§2.8): in the free preview these open S10 (lock card) — the
// lock badge says so before the tap.
const PREVIEW_LOCKED = new Set(['/app/calendar', '/app/create']);

const links = [
  { to: '/app', label: 'navDashboard', Icon: I.home, end: true },
  { to: '/app/calendar', label: 'navCalendar', Icon: I.calendar },
  { to: '/app/create', label: 'newPost', Icon: I.plus, create: true },
  { to: '/app/library', label: 'navLibrary', Icon: I.library },
];

export default function MobileNavigation({ open, onOpen, menuButtonRef }) {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const freePreview = useFreePreview();
  const dash = useDashboardData();
  const ownPublishing = Boolean(freePublishingState(dash.entitlementsError ? null : dash.entitlements || freePreview.entitlements));
  const moreActive = ['/app/plan', '/app/research', '/app/brandkit', '/app/settings', '/app/referrals', '/app/help']
    .some(path => pathname === path || pathname.startsWith(`${path}/`));
  return <nav className="mobile-navigation" aria-label={t('topbar.openMenu')} inert={open ? '' : undefined}>
    {links.map(({ to, label, Icon, end, create }) => <NavLink key={to} to={to} end={end}
      className={({ isActive }) => `mobile-navigation__item${create ? ' mobile-navigation__create' : ''}${isActive ? ' is-active' : ''}`}>
      <span className="mobile-navigation__icon" aria-hidden="true"><Icon size={21} /></span>
      <span>{t(`sidebar.${label}`)}</span>
      {freePreview.active && !ownPublishing && PREVIEW_LOCKED.has(to) && <span className="fp-nav-lock" title={t('freePreview.navLockedHint')} aria-label={t('freePreview.navLockedHint')}><svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" aria-hidden="true"><rect x="4" y="11" width="16" height="10" rx="2" /><path d="M8 11V7a4 4 0 0 1 8 0v4" /></svg></span>}
    </NavLink>)}
    <button ref={menuButtonRef} type="button" className={`mobile-navigation__item${moreActive ? ' is-active' : ''}`} onClick={onOpen}
      aria-expanded={open} aria-controls="app-navigation" aria-haspopup="dialog" title={t('topbar.openMenu')}>
      <svg width="21" height="21" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        <circle cx="5" cy="12" r="2" /><circle cx="12" cy="12" r="2" /><circle cx="19" cy="12" r="2" />
      </svg>
      <span>{t('sidebar.navMore')}</span>
    </button>
  </nav>;
}
